<template>
  <progress-bar>
    <progress-bar-step
      v-for="(step, index) in steps"
      :key="index"
      :active="currentStep == step.position">
      <progress-bar-number :active="currentStep == step.position">
        {{ step.position }}
      </progress-bar-number>
      <progress-bar-text :active="currentStep == step.position">
        {{ $t(step.text) }}
      </progress-bar-text>
    </progress-bar-step>
  </progress-bar>
</template>

<script>
import styled from 'vue-styled-components';
import { mapState } from 'vuex';

const ProgressBar = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  position: relative;
  z-index: 104;
`;

let StepProps = {
  active: Boolean,
};

const ProgressBarStep = styled('li', StepProps)`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

const progressBarNumber = styled('div', StepProps)`
  background-color: var(--primary);
  color: var(--on_primary);

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 14px;
  width: 24px;
  height: 24px;
  margin-right: 14px;
  font-weight: bold;
  opacity: ${props => (props.active ? 1 : 0.5)};
`;
const progressBarText = styled('span', StepProps)`
  color: var(--on_background);
  opacity: ${props => (props.active ? 1 : 0.5)};
`;

export default {
  computed: {
    ...mapState(['currentStep']),
  },
  components: {
    ProgressBar,
    ProgressBarStep,
    progressBarNumber,
    progressBarText,
  },
  data() {
    return {
      steps: [
        {
          position: 1,
          text: 'stepper__first__select_method',
        },
        {
          position: 2,
          text: 'stepper__second__payment_process',
        },
        {
          position: 3,
          text: 'stepper__third__status_page',
        },
      ],
    };
  },
};
</script>

<style></style>
